import { UUID } from 'crypto';
import { ConsumptionBM } from 'src/types/BusinessModel/Aol/ConsumptionBM';
import { Consumption } from 'src/types/ViewModel/Aol/Consumption';

export const mapConsumptionBM = (consumption: ConsumptionBM): Consumption => {
    return {
        consumptionId: consumption.consumptionId,
        noonReportId: consumption.noonReportId,
        bunkeringId: consumption.bunkeringId,
        bunkeringGuid: consumption.bunkeringGuid as UUID,
        engineDataType: consumption.engineType,
        fuelType: consumption.fuelTypeId,
        tankId: consumption.tankId,
        consumptionMt: consumption.consumptionMt,
        cost: null,
    };
};

export const mapConsumptionListBM = (consumption: ConsumptionBM[]): Consumption[] => {
    return consumption?.map((c) => mapConsumptionBM(c)) ?? [];
};

export const mapConsumption = (consumption: Consumption): ConsumptionBM => {
    return {
        consumptionId: consumption.consumptionId,
        noonReportId: consumption.noonReportId,
        bunkeringId: consumption.bunkeringId,
        bunkeringGuid: consumption.bunkeringGuid,
        engineType: consumption.engineDataType,
        fuelTypeId: consumption.fuelType,
        tankId: consumption.tankId,
        consumptionMt: consumption.consumptionMt,
    };
};

export const mapConsumptionList = (consumption: Consumption[]): ConsumptionBM[] => {
    return consumption.filter((c) => c.consumptionMt && c.consumptionMt > 0)?.map((c) => mapConsumption(c)) ?? [];
};
